import { render, staticRenderFns } from "./TerminalRequest.vue?vue&type=template&id=c13544aa"
import script from "./TerminalRequest.vue?vue&type=script&lang=js"
export * from "./TerminalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports